<div class="content_wrapper">
    <app-text page="privacy-policy" contentId="7lw9xQtE7nrORSFrkVSVsV"></app-text>
</div>
